import React from 'react';

import { CoreLink } from '@uncinc/react-drupal-core';

import type { BaseCardProps } from '../types';

const CardLink: React.FC<Pick<BaseCardProps, 'link'>> = (props) => {
  const { link, children } = props;

  return (
    <CoreLink className="Card__link" href={link}>
      {children}
    </CoreLink>
  );
};

export default CardLink;
